import AnalysedCriterion from "./AnalysedCriterion";
import Alert from "../Alert";
import Treatment from "./Treatment";
import TreatmentSelectionModel from "./TreatmentSelectionModel";

export default class TreatmentSelection {
  uid: string;
  criteria: AnalysedCriterion[];
  selectedTreatments: Treatment[];
  availableTreatments: Treatment[];
  autoAssignedTreatments: Treatment[];
  alerts: Alert[];
  apiUrl?: string;

  static toModel(treatmentSelection: TreatmentSelection): TreatmentSelectionModel {
    return {
      uid: treatmentSelection.uid,
      criterionIds: treatmentSelection.criteria.map((c) => c.criterionId),
      selectedTreatmentIds: treatmentSelection.selectedTreatments.map((t) => t.uid),
      availableTreatmentIds: treatmentSelection.availableTreatments.map((t) => t.uid),
      autoAssignedTreatmentIds: treatmentSelection.autoAssignedTreatments.map((t) => t.uid),
      alerts: treatmentSelection.alerts,
      apiUrl: treatmentSelection.apiUrl,
    };
  }
}
